import { CampaignTypeFilter } from 'modules/domains/campaign';
import { AllMessageMediums, GraphQLAlertMetric } from '../../types';
import { sortByMetricName } from './AlertList.utils';
import { AlertListItem } from './AlertListItem';
import { AlertListSkeleton } from './AlertListSkeleton';
import { ListContainer } from './styles';

type AlertListProps = {
  campaignType: CampaignTypeFilter;
  isLoading?: boolean;
  messageMedium: AllMessageMediums;
  metrics: GraphQLAlertMetric[];
};

export const AlertList: React.FC<AlertListProps> = ({
  campaignType,
  isLoading = false,
  messageMedium,
  metrics,
}) => {
  const alphabetizedMetrics =
    metrics?.sort((m1, m2) => sortByMetricName(m1.metricName, m2.metricName)) || [];

  return (
    <ListContainer data-test={`${messageMedium}-${campaignType}-alert-list`}>
      {isLoading ? (
        <AlertListSkeleton />
      ) : (
        alphabetizedMetrics?.map((metric) => {
          return (
            <AlertListItem
              key={`${messageMedium}-${campaignType}-${metric.metricName}-item`}
              metric={metric}
              messageMedium={messageMedium}
              campaignType={campaignType}
            />
          );
        })
      )}
    </ListContainer>
  );
};
